<template>
  <div id="filed-edit">
    <IForm id="editForm" ref="formInline" :model="edit" :elem="editElem" :rules="editRule"
           :label-width="80" :submit="false"  @on-submit="toSubmit">
      <Row>
        <Col span="8">
          <FormItem label="名称" prop="name"><Input v-model="edit.name" type="text" placeholder="请输入名称" maxlength="50"/></FormItem>
        </Col>
        <Col span="8">
          <FormItem :label-width="45" label="别名" prop="alias"><Input v-model="edit.alias" type="text" placeholder="请输入别名" maxlength="50"/></FormItem>
        </Col>
        <Col span="8">
          <FormItem :label-width="45" label="编码" prop="code"><Input v-model="edit.code" type="text" placeholder="请输入编码" maxlength="50" :disabled="edit.id?true:false"/></FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="必填" prop="isRequired">
            <RadioGroup prop="isRequired" v-model="edit.isRequired">
              <Radio style="font-size: 15px;" v-for="item in enums.isOrNot" v-bind:key="item.value"  :label="item.value">{{item.label}}</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="只读" prop="isRead">
            <RadioGroup prop="isRead" v-model="edit.isRead" style="width: 100%;">
              <Radio style="font-size: 15px;" v-for="item in enums.isOrNot" v-bind:key="item.value"  :label="item.value">{{item.label}}</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="单位" prop="unit"><Input v-model="edit.unit" type="text" placeholder="请输入单位"/></FormItem>
        </Col>
        <Col span="12">
          <FormItem label="默认值" prop="defaultValue"><Input v-model="edit.defaultValue" type="text" placeholder="请输入默认值"/></FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="元素类型" prop="elementType">
            <Select v-model="edit.elementType" style="width: 100%;" @on-change="changeElementType">
              <Option v-for="item in enums.elementTypes" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="占列数" prop="columnNumber">
<!--              <Input v-model="edit.columnNumber" type="number" placeholder="请输入占列数" style="font-size: 25px;width: 300px;"/>-->
            <Select v-model="edit.columnNumber" style="width: 100%;">
              <Option v-for="item in enums.columnNumbers" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col v-if="edit.elementType===12" span="12">
          <FormItem label="默认日期" prop="defaultToday">
            <Select v-model="edit.defaultToday" style="width: 100%;">
              <Option v-for="item in enums.defaultDate" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col v-if="edit.elementType===8||edit.elementType===9||edit.elementType===10||edit.elementType===11" span="12">
          <FormItem  label="节点类型" prop="type">
            <Select v-model="edit.type" style="width: 100%;">
              <Option v-for="item in enums.nodeTypes" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col v-if="edit.elementType===1||edit.elementType===2||edit.elementType===3||edit.elementType===15" span="12">
          <FormItem label="值长度" prop="valueLength">
            <Input v-model="edit.valueLength" type="number" placeholder="请输入值长度"/>
          </FormItem>
        </Col>
        <Col v-if="edit.elementType===3" span="12">
          <FormItem label="小数点位数" prop="decimalLimit">
            <Input v-model="edit.decimalLimit" type="number" placeholder="请输入小数点位数"/>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="范围" prop="range">
            <Row>
              <Col span="11"><Input v-model="edit.startRange" type="text" placeholder="请输入开始范围"/></Col>
              <Col span="2" style="text-align: center">~</Col>
              <Col span="11"><Input v-model="edit.endRange" type="text" placeholder="请输入结束范围"/></Col>
            </Row>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="适用年龄" prop="ageId">
            <Row>
              <Col span="11">
                <Select v-model="edit.minAgeId">
                  <Option v-for="item in applicableAgeList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
                </Select>
              </Col>
              <Col span="2" style="text-align: center">~</Col>
              <Col span="11">
                <Select v-model="edit.maxAgeId">
                  <Option v-for="item in applicableAgeList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
                </Select>
              </Col>
            </Row>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="性别">
            <Select v-model="edit.gender" clearable style="width: 100%;">
              <Option v-for="item in enums.genderList" :value="item.code" v-bind:key="item.code"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="互斥值">
            <Select v-model="edit.mutexId" :multiple="true" style="width: 100%;">
              <Option v-for="item in edit.options" :value="item.id" v-bind:key="item.id"  >{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem label="业务类型" prop="businessType">
            <Select v-model="edit.businessType" style="width: 100%;">
              <Option v-for="item in businessTypeList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="状态" prop="status">
            <Select v-model="edit.status" style="width: 100%;">
              <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem label="备注" prop="remark">
            <Input v-model="edit.remark" type="textarea" placeholder="请输入备注" :rows="2"/>
          </FormItem>
        </Col>
      </Row>
      <Row v-if="optionShowTypesCtrl.indexOf(edit.elementType)>-1">
        <Col span="24">
          <button type="button" class="ivu-btn ivu-btn-primary" @click="addChlidNode()"><i class="el-icon-plus"/>添加子节点</button>
        </Col>
      </Row>
      <Row style="margin-top: 10px;">
        <Col span="23">
          <FormItem label="选项配置" v-if="optionShowTypesCtrl.indexOf(edit.elementType)>-1">
           <el-table :data="edit.options" style="width: 100%;" row-key="id" border :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                      :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'left', 'height':'20px', 'margin-top':'10px'}" :cell-style="{'text-align':'left'}">

              <el-table-column fixed prop="name" label="名称">
                <template #default="{ row }">
                  <el-input v-model="row.name" placeholder="请输入名称" maxlength="50" size="mini"/>
                </template>
              </el-table-column>
              <el-table-column prop="mutexArr" label="互斥关系">
                <template slot-scope="{row}">
                  <Select v-model="row.mutexArr" placement="top" sclearable multiple transfer @change="(val)=>{row.mutexArr=val}">
                    <Option v-for="rowItem in edit.options" :value="rowItem.id" v-bind:key="rowItem.id" v-if="rowItem.name">{{ rowItem.name }}</Option>
                  </Select>
                </template>
              </el-table-column>
              <el-table-column prop="isDefault" label="默认选中" width="100">
                <template slot-scope="{row}">
                  <Select v-model="row.isDefault" placement="top" clearable transfer>
                    <Option v-for="rowItem in enums.isOrNot" :value="rowItem.value" v-bind:key="rowItem.value">{{ rowItem.label }}</Option>
                  </Select>
                </template>
              </el-table-column>
             <el-table-column prop="isShow" label="展示" width="100">
               <template slot-scope="{row}">
                 <el-checkbox v-model="row.isShow"  :label="''" :true-label="1" :false-label="2"/>
               </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作">
               <template #default="{ row }">
                 <el-button size="small" type="text" @click="deleteNode(row.id)">删除</el-button>
               </template>
             </el-table-column>
            </el-table>

<!--            <el-tree ref="filedOptionsTree" :data="edit.options" node-key="id" show-checkbox :check-strictly="true" :highlight-current="true" :expand-on-click-node="false">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span style="position: absolute;right: 25%">
                    默认选中
                    <Select v-model="data.isDefault" placement="top" clearable transfer style="margin-left: 5px;">
                      <Option v-for="rowItem in enums.isOrNot" :value="rowItem.value" v-bind:key="rowItem.value">{{ rowItem.label}}</Option>
                    </Select>
                  </span>
                &lt;!&ndash;
                <span>
                  <el-link type="text" size="mini" @click="() => addChlidNode(data)" style="margin-right: 20px;">添加子节点</el-link>
                  <el-link type="danger" size="mini" @click="() => deleteNode(node, data)">删除</el-link>
                </span>
                &ndash;&gt;
              </span>
            </el-tree>-->

          </FormItem>
        </Col>
      </Row>

    </IForm>

  </div>
</template>
<script>

import {_get, _save} from "@/services/screeningConfig/fieldConfig.js";
import {enums} from "@/services/enums";
import {mixins} from "@/mixins";

export default {
  name: "FieldConfigEdit",
  mixins: [mixins],
  data() {
    return {
      optionShowTypesCtrl:[4,5,6,7,8,9,10,11],
      edit: {
        id:"",
        fieldId:"",
        parentId:"",
        name:"",
        alias:"",
        flag:"",
        code:"",
        unit:"",
        minAgeId:"",
        maxAgeId:"",
        startRange:"",
        endRange:"",
        defaultValue:"",
        defaultToday:"",
        elementType:"",
        nodeType:1,
        type:1,
        isRead:1,
        isRequired:1,
        columnNumber:"",
        valueLength:"",
        decimalLimit:"",
        mutexId:"",
        mutexValue:"",
        sorts:"",
        businessType:1,
        status:1,
        remark:"",
        options:[],
      },
      props: {
        children: 'children',
        label: 'label',
      },
      businessTypeList:[
        {label: '通用', value: 1},
        {label: '幼儿园', value: 2},
        {label: '小学', value: 3},
        {label: '中学', value: 4},
        {label: '大学', value: 5},
      ],
      enums: Object.assign({},enums),
      init: "",
      editElem: [],
      editRule: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'},
          {maxlength: 50, message: "名称长度不能超过50", trigger: 'blur'}
        ],
        elementType: [
          {
            required: true,
            message: "请选择元素类型",
            trigger: "change",
            type: 'number'
          }
        ],
        isRequired: [
          {validator:function(rule, value, callback){
              if (value&&value.toString().length>0) {
                callback();
              } else {
                callback(new Error('必填不能为空'));
              }
            }.bind(this), trigger: 'input'
          }
        ],
        isRead: [
          {validator:function(rule, value, callback){
              if (value&&value.toString().length>0) {
                callback();
              } else {
                callback(new Error('只读不能为空'));
              }
            }.bind(this), trigger: 'input'
          }
        ],
        businessTypeId: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "change",
            type: 'number'
          }
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type: 'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.applyApplicableAgeList();
    this.init = Object.assign({}, this.edit);
  },
  computed:{

  },
  methods: {
    changeElementType(val) {
      if (!val || val !== 12) {
        this.edit.defaultToday = "";
      } else if (!val || (val !== 8 && val !== 9 && val !== 10 && val !== 11)) {
        this.edit.nodeType = "";
        this.edit.type = "";
      }
    },
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      const params = {id: row.id};
      this.edit = {};
      _get(params).then(res => {
          if (res.errcode === 1){
            this.edit = res.data;

            let optionIds = [];
            if (this.edit.options){
              this.loadOptionsTreeNode(this.edit.options, optionIds);
            }

            /*if (res.data.options){
              let temp = Object.assign([], res.data.options);
              for (let i = 0; i < temp.length; i++) {
                if (temp[i].mutexId){
                  let tempMutexArr= temp[i].mutexId.split(",");
                  for (let j = 0; j < tempMutexArr.length; j++) {
                    tempMutexArr[j] = tempMutexArr[j]
                  }
                  temp[i].mutexArr = tempMutexArr;
                }
              }
              this.edit.options = temp;
            }*/

            // this.$refs.filedOptionsTree.setCheckedKeys(optionIds);
            this.$forceUpdate();
          } else {
            this.$message.error(res.errmsg);
          }
      }).catch(e=>{
        this.edit = {};
      })
    },
    loadOptionsTreeNode(optionsData, optionIds){
      optionsData.forEach(item=>{
        item.id = !item.id ? (Math.random() * 1000) + "" : item.id;
        item.label = item.name;
        if(item.isShow == 1){
          item.checked = true;
          optionIds.push(item.id);
        }else{
          item.checked = false;
        }

        if(item.children){
          this.loadOptionsTreeNode(item.children, optionIds);
        }else{
          item.children = [];
        }
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      //处理options
      if (this.edit.options){
        let temp = Object.assign([],this.edit.options);
        for (let i = 0; i < temp.length; i++) {
          let mutexArr = temp[i].mutexArr
          if (mutexArr && mutexArr.length > 0){
            temp[i].mutexId= mutexArr.join(",");
          }
          delete temp[i].mutexArr;
        }
        this.edit.options = temp;
      }
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    addChlidNode(){
      if(!this.edit.options){
        this.edit.options = [];
      }
      this.edit.options.push({ name:"",code:"",endDisplayCondition:"",fieldId:this.edit.id,isDefault:1,isShow:1,mutexId:"",mutexValue:"",parentId:"",startDisplayCondition: 1,unit: 1});
    },
    deleteNode(rowId){
      for (let i = 0; i < this.edit.options.length; i++) {
        let temp = this.edit.options[i]
        if (temp.id === rowId){
          this.edit.options.splice(i,1);
        }
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
.custom-tree-node {flex: 1;display: flex;align-items: center;justify-content: space-between;font-size: 14px;}
.custom-tree-node .custom-tree-node-content{display: flex;justify-content: space-between;}
.custom-tree-node .custom-tree-node-content span{margin-left: 3px;}
/deep/ .el-input__inner {height: 35px;line-height: 35px;}
/deep/ .el-input__icon{line-height: 35px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ #editForm .el-table .el-table__cell {padding: 1px 0;}
/deep/ .el-tree-node{margin: 10px 0}
/deep/ .ivu-input[disabled], fieldset[disabled] .ivu-input {background-color: #f3f3f38c;color: #515a6e;}

</style>
